<button class="custom-button" [style.background-color]="backgroundColor" [style.color]="textColor"
    [style.border]="backgroundColor === '#FFFFFF' || backgroundColor === 'white' ? '1px solid ' + textColor : 'none'"
    [style.width]="width"
    (click)="handleClick()">
    <span>{{ text }}</span>
    <div class="icon-container" [style.background-color]="textColor">
        <lucide-icon name="arrow-up-right" [style.color]="backgroundColor" size="24"></lucide-icon>
    </div>
</button>
